// CheckoutModal.jsx
import React, { useState, useMemo } from "react";
import "./CheckoutModal.css";
import Select from "react-select";
import countryList from "react-select-country-list";

const CheckoutModal = ({ isOpen, onClose, planKey, yearly, handleCheckout }) => {
  const [billing, setBilling] = useState({
    street: "",
    city: "",
    state: "",
    zipcode: "",
    country: "US", // default country code
  });

  // Get full country list [{ value: "US", label: "United States" }, ...]
  const options = useMemo(() => countryList().getData(), []);

  const handleChange = (e) => {
    setBilling({ ...billing, [e.target.name]: e.target.value });
  };

  const handleCountryChange = (selected) => {
    setBilling({ ...billing, country: selected.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleCheckout(planKey, yearly, billing);
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()} // stop background close
      >
        <h2>Billing Information</h2>
        <form onSubmit={handleSubmit} className="billing-form">
          <input
            type="text"
            name="street"
            placeholder="Street"
            value={billing.street}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="city"
            placeholder="City"
            value={billing.city}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="state"
            placeholder="State"
            value={billing.state}
            onChange={handleChange}
            required
          />
          <input
            type="text"
            name="zipcode"
            placeholder="Zipcode"
            value={billing.zipcode}
            onChange={handleChange}
            required
          />

          {/* Country dropdown using react-select */}
          <Select
            options={options}
            value={options.find((opt) => opt.value === billing.country)}
            onChange={handleCountryChange}
            className="country-select"
          />

          <button type="submit" className="pay-btn">
            Pay Now
          </button>
        </form>
        <button className="close-btn" onClick={onClose}>
          ✕
        </button>
      </div>
    </div>
  );
};

export default CheckoutModal;
